import { PRICE_CHANGED, PRICE_CHANGED_SEATSELL1 } from '@/src/constants/itineraryStatus'
import { Fare, ItineraryResponse } from '@/src/types/itinerary'
import { getFares, getInsurances, getSelectedInsurance } from '@/src/utils/itinerary/flightTransformers'

export const transformItineraryData = (itineraryData: ItineraryResponse) => {
    const {
        flights,
        itineraryStatus,
        searchCriteria,
        vasAncillaries,
        meta,
        passengers,
        customer,
        fares,
        updatedFareResponse,
        currencyConversionDetails,
        paxPricingInfoJson
    } = itineraryData || {}

    const faresList = flights ? getFares(flights, paxPricingInfoJson, vasAncillaries) : []
    const insuranceList = vasAncillaries ? getInsurances(vasAncillaries) : []
    const selectedInsurances = insuranceList ? getSelectedInsurance(insuranceList) : []
    const isInsuranceTermsAndConditionsChecked = true
    const isPriceChange = [PRICE_CHANGED_SEATSELL1, PRICE_CHANGED].includes(itineraryStatus)

    const fareFamilyEnabledOnReview = meta?.fareFamilyEnabledOnReview
    let fareFamilyFares: Fare[] = []
    if (fareFamilyEnabledOnReview) {
        fareFamilyFares = fares
    }

    return {
        itineraryData,
        flights,
        itineraryStatus,
        searchCriteria,
        faresList,
        meta,
        passengers,
        customer,
        fareFamilyFares,
        currencyConversionDetails,
        insurance: {
            insuranceList,
            selectedInsurances,
            isInsuranceTermsAndConditionsChecked
        },
        metaData: {
            priceChangePopupData: {
                updatedFareResponse: updatedFareResponse || {},
                isPriceChange,
                priceChangePopupShown: false,
                oldPrice: updatedFareResponse?.oldPrice || 0,
                newPrice: updatedFareResponse?.totalPrice || 0
            }
        }
    }
}
